{
  "title": "Workflow Decisions",
  "description": "Every tool call an agent proposes is evaluated against its policy. Approve or deny what the engine escalated.",
  "noDataTitle": "No Workflows Yet",
  "noDataMessage": "Workflow authorization decisions will appear here once agents start proposing tool calls.",
  "noFilteredDataMessage": "No workflows match the selected filters.",
  "notFoundTitle": "Workflow Not Found",
  "notFoundMessage": "This workflow does not exist, or it could not be fetched.",
  "status": {
    "pending": "Pending",
    "approved": "Approved",
    "denied": "Denied",
    "expired": "Expired"
  },
  "filter": {
    "all": "All",
    "pending": "Pending",
    "approved": "Approved",
    "denied": "Denied",
    "expired": "Expired",
    "agent": "Agent",
    "allAgents": "All Agents",
    "policy": "Policy",
    "allPolicies": "All Policies",
    "tool": "Tool"
  },
  "table": {
    "status": "Status",
    "workflow": "Workflow",
    "agent": "Agent",
    "policy": "Policy",
    "toolCalls": "Tool Calls",
    "requested": "Requested"
  },
  "gate": {
    "callsNeedApproval": "{{count}} call needs your approval",
    "callsNeedApproval_plural": "{{count}} calls need your approval",
    "help": "Approving runs the calls in dependency order. The reason you enter is recorded on the decision and returned to the agent.",
    "reasonPlaceholder": "Reason (optional)",
    "approve": "Approve Workflow",
    "deny": "Deny"
  },
  "detail": {
    "toolCalls": "Tool Calls",
    "callCount": "{{count}} call",
    "callCount_plural": "{{count}} calls",
    "noItems": "This workflow carries no tool calls.",
    "runsAfter": "runs after {{deps}}",
    "request": "Request debug info",
    "agent": "Agent",
    "agentInstance": "Agent Instance",
    "policy": "Policy",
    "scope": "Scope",
    "origin": "Origin",
    "requestId": "Request Id",
    "decisionId": "Decision Id",
    "timeline": "Timeline",
    "agentAndPolicy": "Agent & Policy",
    "noLongerExists": "no longer exists",
    "approvedBy": "Approved by {{by}}",
    "deniedBy": "Denied by {{by}}",
    "byPolicy": "policy",
    "expired": "Expired before a decision was made",
    "saveAs": "Save workflow as",
    "saveAsPolicyCase": "Policy Test Case",
    "saveAsLibraryCase": "Test Case Library",
    "saveAsCaseBody": "This workflow's tool calls, with the decisions the policy reached for them as expectations, saved as a standalone case any policy's suite can use."
  },
  "timeline": {
    "recorded": "Workflow recorded",
    "evaluated": "Policy evaluated",
    "awaiting": "Awaiting approver",
    "recourse": {
      "allow": "Every call allowed; no approver required.",
      "deny": "Denied without escalation.",
      "approval_required": "Escalated to the approval queue."
    }
  },
  "notification": {
    "pending": "{{count}} workflow awaiting approval",
    "pending_plural": "{{count}} workflows awaiting approval",
    "pendingMore": "{{count}}+ workflows awaiting approval",
    "description": "Agents are waiting on a decision before these tool calls can run. Open a workflow to approve or deny it.",
    "viewAll": "View the approval queue"
  },
  "fetchFailed": "An error occurred while trying to fetch workflows.",
  "decideFailed": "An error occurred while trying to record the decision.",
  "approveSuccess": "Workflow approved.",
  "denySuccess": "Workflow denied."
}
